const Data = [
    {
        name: "Sumit Deora",
        position: "Finance Head",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Adicherla Vaibhav",
        position: "Finance Head",
        imageUrl: "/assets/images/members/Heads23/AdicherlaVaibhav.JPG",
        facebookLink: "https://www.facebook.com/profile.php?id=100075255438778",
        linkedinLink: "https://www.linkedin.com/in/vaibhav-adicherla-076780188/",
        email: "adicherla.vaibhav@gyws.org"
    },
    {
        name: "Ishika Modi",
        position: "Finance Head",
        imageUrl: "/assets/images/members/Heads23/Ishika Modi.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100075462040432&mibextid=ZbWKwL",
        linkedinLink: "https://www.linkedin.com/in/ishika-modi-117354227?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "ishika.modi@gyws.org"
    },
]

export default Data;